import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { PORTALS_ENDPOINT } from '../app.constants';
import { Portal } from '../models/portal.model';

@Injectable()
export class PortalsService {

    public portals$: BehaviorSubject<Portal[]> = new BehaviorSubject<Portal[]>([]);


    constructor(private http: HttpClient) {
        this.http.get<Portal[]>(PORTALS_ENDPOINT).subscribe(portals => {
            this.portals$.next(portals);
        });
    }

    getData(): Promise<Portal[]> {
        return this.http.get<Portal[]>(PORTALS_ENDPOINT).toPromise();
    }
}
